export const ACC_TOOLBAR_ROOT_ID = 'mic-init-access-tool';

export const ACC_TOOLBAR_CONSTRUCTOR_ARGS = {
  reportLink: 'https://msu.co1.qualtrics.com/jfe/form/SV_6S9MV7pPpoqFwTY',
  link: `${window.location.origin}/accessibility-statement`,
};
